import { CurrencyField } from "./CurrencyField";
import SortableEntryWrapper from "./SortableEntryWrapper";

interface MonthlyBudgetEntryProps {
  id: string;
  index: number;
  value: number | undefined;
  onChange: (value: number) => void;
  onRemove: () => void;
  canRemove: boolean;
  autoFocus?: boolean;
}

export default function MonthlyBudgetEntry({
  id,
  index,
  value,
  onChange,
  onRemove,
  canRemove,
  autoFocus,
}: MonthlyBudgetEntryProps) {
  return (
    <SortableEntryWrapper id={id} onRemove={onRemove} canRemove={canRemove}>
      <CurrencyField
        label={`Monthly Budget ${index + 1}`}
        value={value}
        onChange={onChange}
        fullWidth
        margin="none"
        required
        autoFocus={autoFocus}
      />
    </SortableEntryWrapper>
  );
}
